// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_sr-5";
export var filledCircle = "_sr-4";
export var historyEntry = "_sr-3";
export var messageSideLeft = "_sr-1";
export var messageSideRight = "_sr-2";
export var orderTrackingCarouselWrapper = "_sr-6";
export var orderTrackingInfoContainer = "_sr-0";